<template>
  <ItemTitle type="xianshi" class="physical-home-time-list-container">
    <!-- 标题 -->
    <template v-slot:header>
      <img src="../imgs/home_xianshi_logo.png" alt="">
      <p>限时好货</p>
    </template>
    <!-- 内容 -->
    <!-- 计时器 -->
    <Time :roundTime="roundTime" v-if="listData.length"/>
    <ul class="list" v-loading="isLoading"> 
      <HomeItem v-for="(item, index) in listData" :key="index" :item="item"/>
    </ul>
    <md-button class="more-btn" @click="handleToTimeLimit">更多场次 <md-icon name="rectangle" size="xs"/> </md-button>
  </ItemTitle>  
</template>

<script>
import { getDdpGoodList } from "@/api/distribution"
import ItemTitle from "./itemTitle"
import HomeItem from "./homeItem"
import Time from "./time"
export default {

  data() {
    return {
      roundTime: '',
      listData: [],
      isLoading: false,    
    }
  },
  
  methods: {
    load() {
      this.isLoading = true;
      getDdpGoodList({roundTime: ''}).then(res=>{
        this.isLoading = false;
        if(res.success) {
          const { ddqGoodInfoVtoList, roundsList } = res.data;
          let list = ddqGoodInfoVtoList || [];
          this.listData = list;
          let t = roundsList.find(item=>{
            return item.status === 2;
          })
          this.roundTime = t.ddqTime;
        }
      })
    },
    //切换下一场，这里进行重新获取列表数据
    onChangeNext() {
      this.load()
    },
    handleToTimeLimit() {
      this.$router.push({name: 'sales'})
    }
  },

  created() {
    this.load()
  },

  components: {
    ItemTitle,
    HomeItem,
    Time,
  },
}
</script>

<style lang="scss" scoped>
.physical-home-time-list-container {
  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .physical-home-item-container {
      width: 330px;
    }
  }
  .more-btn {
    margin: 48px auto 0;
    width: 226px;
    height: 64px;
    line-height: 1;
    border: 2px solid #E1E1E6;
    border-radius: 8px;
    font-size: 28px;
    font-weight: 400;
    color: #636666;
    .md-button-content {
      height: 64px;
      line-height: 1;
      i {
        margin-left: 4px;
      }
    }
  }
}
</style>